// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-select[data-v-a5f03b64],\n.el-cascader[data-v-a5f03b64] {\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
